// 대한민국 공휴일 데이터 (2026년)
export const koreanHolidays2026: { [key: string]: string } = {
  // 1월
  '2026-01-01': '신정',
  
  // 2월
  '2026-02-16': '설날 연휴',
  '2026-02-17': '설날',
  '2026-02-18': '설날 연휴',
  
  // 3월
  '2026-03-01': '삼일절',
  '2026-03-02': '삼일절 대체공휴일', // 3/1(일) → 3/2(월)
  
  // 4월
  
  // 5월
  '2026-05-05': '어린이날',
  '2026-05-19': '부처님오신날',
  
  // 6월
  '2026-06-06': '현충일',
  '2026-06-08': '현충일 대체공휴일', // 6/6(토) → 6/8(월)
  
  // 7월
  
  // 8월
  '2026-08-15': '광복절',
  '2026-08-17': '광복절 대체공휴일', // 8/15(토) → 8/17(월)
  
  // 9월
  '2026-09-24': '추석 연휴',
  '2026-09-25': '추석',
  '2026-09-26': '추석 연휴',
  
  // 10월
  '2026-10-03': '개천절',
  '2026-10-05': '개천절 대체공휴일', // 10/3(토) → 10/5(월)
  '2026-10-09': '한글날',
  
  // 11월
  
  // 12월
  '2026-12-25': '크리스마스',
};

/**
 * 특정 날짜가 한국 공휴일인지 확인
 */
export const isKoreanHoliday = (date: Date): boolean => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const dateKey = `${year}-${month}-${day}`;
  
  return dateKey in koreanHolidays2026;
};

/**
 * 특정 날짜의 공휴일 이름 가져오기
 */
export const getKoreanHolidayName = (date: Date): string | null => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const dateKey = `${year}-${month}-${day}`;
  
  return koreanHolidays2026[dateKey] || null;
};

/**
 * 특정 월의 휴무 가능 일수 계산 (토요일 + 일요일 + 공휴일)
 * 중복 제거: 주말과 공휴일이 겹치는 경우 한 번만 카운트
 */
export const getMonthOffDaysCount = (year: number, month: number): number => {
  const firstDay = new Date(year, month - 1, 1);
  const lastDay = new Date(year, month, 0);
  
  const offDays = new Set<string>();
  const currentDate = new Date(firstDay);
  
  while (currentDate <= lastDay) {
    const dayOfWeek = currentDate.getDay();
    const dateKey = `${year}-${String(month).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
    
    // 토요일(6) 또는 일요일(0) 또는 공휴일
    if (dayOfWeek === 0 || dayOfWeek === 6 || isKoreanHoliday(currentDate)) {
      offDays.add(dateKey);
    }
    
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return offDays.size;
};
